/**
 * MetricCard - KPI card with colored top border and trend
 */

import React from 'react';
import { TrendingUp, TrendingDown, Info } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { Tooltip } from '@shared/components';

const MetricCard = ({ label, value, subtext, info, change, changeLabel, sparkData = [], color = '#3b82f6' }) => {
  const isPositive = change >= 0;

  return (
    <div
      className="card p-5 hover:shadow-md transition-shadow"
      style={{ borderTop: `3px solid ${color}` }}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
            {label}
            {info && (
              <Tooltip content={info}>
                <button
                  type="button"
                  aria-label="More info"
                  className="inline-flex items-center ml-1 align-middle cursor-help text-gray-400 hover:text-gray-600 focus:text-gray-600 focus:outline-none"
                >
                  <Info size={12} />
                </button>
              </Tooltip>
            )}
          </p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtext && (
            <p className="text-xs text-gray-500 mt-1">{subtext}</p>
          )}
          {change !== undefined && (
            <div className={`flex items-center mt-2 text-xs ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
              {isPositive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
              <span className="ml-1">{isPositive ? '+' : ''}{change}%</span>
              {changeLabel && <span className="ml-1 text-gray-400">{changeLabel}</span>}
            </div>
          )}
        </div>

        {sparkData.length > 0 && (
          <div className="w-20 h-12" role="presentation" aria-hidden="true">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={sparkData}>
                <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(MetricCard);
